import PropTypes from 'prop-types';
import React from 'react';

import FactOrFiction from '../../components/FactOrFiction';
import Text from '../../components/TextWithAudio';

import styles from './styles.less';

export default function AnswerFactOrFiction(_ref) {
  var message = _ref.message,
      text = _ref.text,
      audioSource = _ref.audioSource;

  return React.createElement(
    'div',
    { className: styles.container },
    (text || audioSource) && React.createElement(
      'div',
      null,
      React.createElement('div', { className: styles.message, dangerouslySetInnerHTML: { __html: message } }),
      React.createElement(Text, { text: text, audioSource: audioSource })
    ),
    React.createElement(FactOrFiction, null)
  );
}

AnswerFactOrFiction.propTypes = process.env.NODE_ENV !== "production" ? {
  message: PropTypes.string,
  text: PropTypes.string,
  audioSource: PropTypes.string
} : {};

AnswerFactOrFiction.defaultProps = {
  message: '',
  text: '',
  audioSource: ''
};